import React, { useEffect, useState } from "react";
import { Col } from "antd";
import { useSelector, useDispatch } from "react-redux";

import PieChart from "../Charts/PieChart";
import { setAnalytics } from "../../store/actions/analyticsActions";
import useWindowResize from "../../hooks/useWindowResize";
import { renderTitle } from "../Backlinks/utils";

const SessionAnalytics = (props) => {
  const dispatcher = useDispatch();
  const isMobile = useWindowResize();
  const domain = useSelector((state) => state.domains.currentDomain);
  const analytics = useSelector((state) => state.analytics.analytics);
  const [keywordStatusWise, setkeywordStatusWise] = useState(null);

  useEffect(() => {
    if (domain) {
      dispatcher(setAnalytics(domain._id));
    }
  }, [domain]);

  useEffect(() => {
    if (analytics) {
      setkeywordStatusWise(
        analytics.keywordStatusWise.map((keyword) => {
          return {
            id:
              keyword._id.rankStatusWise === "no_change"
                ? "no impact"
                : keyword._id.rankStatusWise,
            label:
              keyword._id.rankStatusWise === "no_change"
                ? "no impact"
                : keyword._id.rankStatusWise,
            value: keyword.count,
          };
        })
      );
    }
  }, [analytics]);

  return (
    <>
      <Col
        lg={6}
        md={12}
        xs={24}
        sm={24}
        style={{ paddingRight: "15px", marginBottom: isMobile ? "16px" : 0 }}
      >
        <PieChart
          data={keywordStatusWise}
          title={renderTitle(
            "Keyword Rank Stats (Today)",
            "You can use the Keyword Rank Stats (Today) report to identify keywords that are driving traffic to your website and to track your progress in improving your rankings."
          )}
        />
      </Col>
    </>
  );
};

export default SessionAnalytics;
